import { ambiguous_dna_letters } from "./bioData";
export default function guessIfSequenceIsDnaAndNotProtein(seq, options = {}) {
  const { threshold = 0.9, loose } = options;
  const dnaLetters = options.dnaLetters || loose ? [...ambiguous_dna_letters.split(""), "U"] : ["G", "A", "T", "C", "U"];
  const dnaLetterMap = dnaLetters.reduce((acc, letter) => {
    acc[letter.toUpperCase()] = true;
    return acc;
  }, {});
  let count = 0;
  if (!seq || !seq.length) return true;
  for (let index = 0; index < seq.length; index++) {
    const letter = seq[index];
    if (dnaLetterMap[letter.toUpperCase()]) {
      count = count + 1;
    }
  }
  if (count / seq.length > threshold) {
    return true;
  }
  return false;
}
